import {useTranslation} from 'react-i18next';
import {Divider} from 'antd';
import Form from '../shared/form/Form';
import FormItem from '../shared/form/FormItem';
import Input from '../shared/inputs/Input';
import {ValidationRules} from '../../utils/validationRules';
import {EnDash} from '../shared/unicodeWrapper/EnDash';
import DefaultFormActions from '../shared/form/DefaultFormActions';

export const ManualSensorDataWidgetForm = ({sensor, onSubmit, onCancel, saving}) => {
  const [form] = Form.useForm();
  const {t} = useTranslation();

  return (
    <Form
      form={form}
      onFinish={onSubmit}
    >
      <Divider
        orientation={'left'}
      >
        {sensor?.label}
      </Divider>
      <FormItem
        name={'value'}
        rules={[ValidationRules.required]}
        label={t('manualSensorDataWidget.value')}
      >
        <Input
          type={'number'}
          addonAfter={sensor?.unitOfMeasure?.label || EnDash()}
        />
      </FormItem>
      <DefaultFormActions
        onCancel={onCancel}
        saving={saving}
      />
    </Form>
  );
};
